module.exports = __webpack_public_path__ + "img/rg.a6377711.jpg";